'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconSpinner, iconSpinnerTag } from '@ni/nimble-components/dist/esm/icons/spinner';
import { wrap } from '../../utilities/react-wrapper';

export type { IconSpinner };
export { iconSpinnerTag };
export const NimbleIconSpinner = wrap(IconSpinner);